import React from 'react';
import { Link } from 'react-router-dom';
import './DataMethodology.css';

const DataMethodology = () => {
    return (
        <div className="container">
            <nav className="navbar">
                <Link to="/" className="navbar-logo">
                    <img src="/huntorca-logo.png" alt="HuntOrca Logo" className="logo-img" />
                    <h1>HuntOrca</h1>
                </Link>
                <div className="navbar-links">
                    <Link to="/pricing" className="navbar-link">Pricing</Link>
                    <Link to="/solutions" className="navbar-link">Solutions</Link>
                    <Link to="/data-methodology" className="navbar-link active">Data & Methodology</Link>
                    <Link to="/dashboard" className="navbar-button">Dashboard</Link>
                </div>
            </nav>

            <main className="methodology-main">
                <section className="methodology-hero">
                    <h1>Transparency Builds Trust</h1>
                    <p>We believe that the most sophisticated buyers deserve to know how we source, clean, and enrich our data. Here's a look at our process.</p>
                </section>

                <section className="methodology-content">
                    <div className="methodology-section">
                        <h2>Our "Three-Legged Stool" Approach to Data</h2>
                        <p>Our data superiority comes from a multi-faceted approach that combines quantitative data, firmographic details, and qualitative analysis.</p>
                        <div className="three-legged-stool">
                            <div className="stool-leg">
                                <h3>1. Performance Data</h3>
                                <p>We capture core operational metrics directly from the source. This includes tracking building permits, interconnection applications, and other official filings to understand installation volume, project velocity, and cycle times for every active installer.</p>
                            </div>
                            <div className="stool-leg">
                                <h3>2. Firmographic Enrichment</h3>
                                <p>A list of projects is not enough. We enrich every installer profile with crucial business data, including company size, years in business, key contacts, service areas, and equipment preferences. This gives you the context you need to qualify leads effectively.</p>
                            </div>
                            <div className="stool-leg">
                                <h3>3. Qualitative Intelligence</h3>
                                <p>We use proprietary AI tools to analyze installer websites, customer reviews, and other public-facing materials. This provides a qualitative summary of an installer's focus, their marketing messaging, and customer sentiment, which you can't find in a database.</p>
                            </div>
                        </div>
                    </div>

                    <div className="methodology-section">
                        <h2>Our "Secret Sauce": Proprietary Scores</h2>
                        <p>While we can't give away the exact formulas, our proprietary scores are designed to give you an instant read on an installer's health, efficiency, and market position.</p>
                        <div className="secret-sauce">
                            <div className="sauce-item">
                                <h3>Installer Efficiency Score</h3>
                                <p>This score quantifies an installer's operational performance, factoring in metrics like average project completion time, permit approval rates, and installation velocity. A higher score means a more efficient, reliable partner.</p>
                            </div>
                            <div className="sauce-item">
                                <h3>Installer Risk Scoring</h3>
                                <p>We help you mitigate risk by analyzing factors like license status, bond information, customer complaints, and business stability. Our risk score gives you a clear signal on whether an installer is a safe bet.</p>
                            </div>
                            <div className="sauce-item">
                                <h3>Cost Competitiveness Score</h3>
                                <p>By analyzing project cost data submitted in permit applications and other sources, we provide insight into an installer's cost-per-watt and overall financial competitiveness, helping you understand their position in the market.</p>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <footer className="footer">
                <p>&copy; {new Date().getFullYear()} HuntOrca. All rights reserved.</p>
                <p>Email: <a href="mailto:info@huntorca.com">info@huntorca.com</a></p>
            </footer>
        </div>
    );
};

export default DataMethodology; 